import { createTranslations } from '@npco/common-utils-translations'

export const markAsSelfTranslations = createTranslations({
  businessTypeRadioDescription: 'Is this your business?',
  personTypeRadioDescription: 'Is this you?',
  errorRequired: 'Please select an option.',
})
